import React, { useEffect, useRef, useState } from 'react';
import { useTransition, animated } from '@react-spring/web';
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger';
import { LazyLoadImage } from 'react-lazy-load-image-component';


import './Figure.css'
import './../Theme/Theme.css'

gsap.registerPlugin(ScrollTrigger);

interface FigureProps {
  src: string;
  alt: string;
  id: string;
  label: string;
  position: FigurePosition;
}
export enum FigurePosition {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center'
}

const Figure: React.FC<FigureProps> = ({ src, alt, id, label, position }) => {
  const [isFullscreen, setFullscreen] = useState(false);
  const figureRef = useRef<HTMLDivElement>(null);
  const enterFullScreenFigure = (): void => {
    setFullscreen(true);
  }
  const exitFullScreenFigure = () => {
    setFullscreen(false);
  }

  useEffect(() => {
    gsap.fromTo(`.figure-image#${id}`, {
      scale: 1.5,
      translate: '-25% -25%',
      filter: 'brightness(0.1)',
    },
    {
      scrollTrigger: {
        trigger: `.figure-image-container.image-container-regular#${id}`,
        toggleActions: 'play none none none'
      },
      filter: 'brightness(1)',
      scale: 1,
      translate: '-0% -0%',
      duration: 1
    });
  }, [id]);

  const transition = useTransition(isFullscreen, {
    from: {
      top: 0, left: 0, zIndex: 3,
      y: 1000,
      scale: 0.2,
      padding: 10,
      backdropFilter: 'blur(2px)',
      opacity: 0,
      backgroundColor: 'hsla(0, 0%, 90%, 0)',
      width: '100%', height: '100%'
    },
    enter: item => async (next) => {
      // await next({ top: 0, left: 0, position: 'fixed', zIndex: 3, padding: 10, delay: 0 })
      await next({
        y: 0,
        opacity: 1,
        scale: 0.75,
        backdropFilter: 'blur(0px)',
        backgroundColor: 'hsla(0, 0%, 90%, 0)',
      })
      await next({
        scale: 1,
        backdropFilter: 'blur(8px)',
        backgroundColor: 'hsla(0, 0%, 0%, .75)',
      })

    },
    leave: item => async (next) => {
      // await next({ top: 0, left: 0, position: 'fixed', zIndex: 3, padding: 10, delay: 0 })
      await next({
        backgroundColor: 'hsla(0, 0%, 0%, 0)',
        y: 1000,
        scale: 0.2,
        opacity: 0,
        backdropFilter: 'blur(0px)',
      });
    }
  });

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@700&display=swap" rel="stylesheet"></link>
      <div ref={figureRef} className={`figure grid-${position}`} id={id}>
        <div className="figure-image-container image-container-regular" id={id} onClick={enterFullScreenFigure}>
          <img src={src} alt={alt} className="figure-image" id={id} />
        </div>
        {label.length > 0 && <p className="slide-image-description" id={id}>{label}</p>}
      </div>
      {transition((style, isFullScreen) => isFullScreen ?
        <animated.div style={{ ...style, position: 'fixed' }}>
          <div className={`figure fullscreen grid-${position}`} id={id}>
            <div className="figure-image-container" id={id} onClick={exitFullScreenFigure}>
              <img src={src} alt={alt} className="figure-image" id={id} />
            </div>
            {label.length > 0 && <p className="slide-image-description" id={id}>{label}</p>}
          </div>
        </animated.div> : '')}
    </>
  );
};

export default Figure;
